import React from "react";
import { Link } from "react-router-dom";
import PostFormsAccessControl from "../../PostForms/PostFormsAccessControl";
import "./BranchCollectionCapsule.scss";

const BranchCollectionCapsule = ({
    parentForm,
    branchCollectionId,
    branchCollectionName,
    branchCollectionType,
}) => {
    const branchCollection = {
        form: parentForm,
        branchCollectionId,
        branchCollectionName,
        branchCollectionType,
    };
    return (
        <PostFormsAccessControl>
            <Link
                to={{
                    pathname: `/t-sam/branch-collection/${branchCollectionId}/view`,
                    state: { branchCollection },
                }}>
                <div
                    className='branch__collection__capsule'
                    id={branchCollectionId}>
                    {branchCollectionName}
                </div>
            </Link>
        </PostFormsAccessControl>
    );
};

export default BranchCollectionCapsule;
